import card from './cardId/cardReducer'
import app from './app/appReducer'
import transaction from './transaction/reducers'

const rootReducer = { card, app, transaction }
export default rootReducer;